export const widgetConfig = {
    hotelId: 'rivelian',
    ticker: 'riveliangrandmenorca',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'https://reservationsgrandmenorca.rivelianhotels.com/',
    urlChain: '',
    urlHotel: 'hotel',
    showChildAges: true,
    noOnDesktop: false,
    type: 'hotel',
    maxRooms: '5',
    showAllHotelsOption: 'false',
    monthsToDisplay: 2,
    minDate: '2026-08-01',
};
